export default {
  payChannel: 'Payment Channels',
  cashierDesk: 'Checkout Counter',
  billAddress: 'Bill Address',
  paySuccess: 'Payment Successful',
  payError: 'Payment Failure',
  harvestAddress: 'Shipping Address',
  orderAddress: 'Billing address',
  selectAddress: 'Select a shipping address',
  addOrderAddress: 'Please add the billing address first',
  addSelectAddress: 'Please select a shipping address',
  noAddress: 'No shipping address available',
  holder: {
    inputPayPwd: 'Please set the payment password',
    returnExchange: 'Payment not completed. Unable to process return/exchange request. ',
  },
  transferTitle: 'Bank Transfer',
  changeAddress: 'Change Address',
  editText: 'Edit',
  payWithbalance: 'Pay With acbuy Balance',
  bankTransferRemittance: 'Bank Transfer',
  transferTips:
    '0 Service Fee On acbuy For Remittance. The Higher The Order Amount, The More Savings!',
  pay: 'Top-Up Offers',
  plsSetPsd: 'Please set payment password',
  thirdPayTips: 'Payments are available worldwide and in multiple currencies',
  payProcessing: 'Payment processing',
  payWaitingText: 'Expect to wait 1-2 minutes, please pay the result later',
  coinpalTips:
    'Digital currency (virtual currency) top-ups are non-refundable and cannot be withdrawn. If you accept this, please proceed with the top-up.',
  payStatusTips: `We haven't received your payment result yet. Please confirm your payment status.`,
  payErrorStatusTips: 'Payment failed. Please try another payment method.',
}
